module.exports = __webpack_public_path__ + "img/alentour3.ee5a8018.jpg";